<template>
  <div class="modal-component" v-esc="escape">
    <transition name="modal">
      <div :style="{ 'max-width': maxWidth }" :class="`modal-mask size-${size}`">
        <div class="modal-wrapper">
          <div
            :class="`modal-container${isMsg ? ' msg-modal-container' : ''}`"
            :style="{ 'border-radius': borderRadius }"
          >
            <div class="modal-header">
              <button
                v-if="showCloseButton"
                type="button"
                class="close"
                @click="close"
                aria-label="Close"
              >
                <i class="fa fa-times"></i>
              </button>
              <slot name="header">
                <button class="close-button" @click="close">
                  <i class="fa white-icon fa-times"></i>
                </button>
              </slot>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>
            <div class="modal-footer">
              <slot v-if="showFooterCloseButton" name="footer"> </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'v-modal',
  props: {
    showFooterCloseButton: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    borderRadius: {
      type: String,
      default: '4px',
    },
    maxWidth: {
      type: String,
      default: 'auto',
    },
    closeOnEscape: {
      type: Boolean,
      required: false,
      default: true,
    },
    isMsg: Boolean,
  },
  mounted: function () {
    document.body.classList.add('modal-open-set')
  },
  destroyed: function () {
    document.body.classList.remove('modal-open-set')
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    escape: function (event) {
      if (this.closeOnEscape) {
        this.$emit('close')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './modal.component.scss';
</style>
